import { sharedCachedFonts } from '../shared';

export const fhsCachedFonts = sharedCachedFonts;
